export enum PosAnimatedImageNames {
  ExpertWhite = 'Expert-White',
  ExpertWhiteDelay = 'Expert-White-Delay',
  ExpertBlack = 'Expert-Black',
  ExpertBlackDelay = 'Expert-Black-Delay',
  GeneratingBlack = 'Generating-Black',
  GeneratingBlackDelay = 'Generating-Black-Delay',
  GeneratingWhite = 'Generating-White',
  GeneratingWhiteDelay = 'Generating-White-Delay',
  HelloBlack = 'Hello-Black',
  HelloBlackDelay = 'Hello-Black-Delay',
  HelloWhite = 'Hello-White',
  HelloWhiteDelay = 'Hello-White-Delay',
  HelpWhite = 'Help-White',
  HelpWhiteDelay = 'Help-White-Delay',
  HelpBlack = 'Help-Black',
  HelpBlackDelay = 'Help-Black-Delay',
  IdleBlack = 'Idle-Black',
  IdleBlackDelay = 'Idle-Black-Delay',
  IdleWhite = 'Idle-White',
  IdleWhiteDelay = 'Idle-White-Delay',
  LoadingBlack = 'Loading-Black',
  LoadingBlackDelay = 'Loading-Black-Delay',
  LoadingWhite = 'Loading-White',
  LoadingWhiteDelay = 'Loading-White-Delay',
  NegativeBlack = 'Negative-Black',
  NegativeBlackDelay = 'Negative-Black-Delay',
  NegativeWhite = 'Negative-White',
  NegativeWhiteDelay = 'Negative-White-Delay',
  PositiveBlack = 'Positive-Black',
  PositiveBlackDelay = 'Positive-Black-Delay',
  PositiveWhite = 'Positive-White',
  PositiveWhiteDelay = 'Positive-White-Delay',
  KonnectSymbol = 'Konnect-Symbol',
}

export type PosAnimatedImagesId =
  | 'ExpertWhite'
  | 'ExpertWhiteDelay'
  | 'ExpertBlack'
  | 'ExpertBlackDelay'
  | 'GeneratingBlack'
  | 'GeneratingBlackDelay'
  | 'GeneratingWhite'
  | 'GeneratingWhiteDelay'
  | 'HelloBlack'
  | 'HelloBlackDelay'
  | 'HelloWhite'
  | 'HelloWhiteDelay'
  | 'HelpBlack'
  | 'HelpBlackDelay'
  | 'HelpWhite'
  | 'HelpWhiteDelay'
  | 'IdleBlack'
  | 'IdleBlackDelay'
  | 'IdleWhite'
  | 'IdleWhiteDelay'
  | 'LoadingBlack'
  | 'LoadingBlackDelay'
  | 'LoadingWhite'
  | 'LoadingWhiteDelay'
  | 'NegativeBlack'
  | 'NegativeBlackDelay'
  | 'NegativeWhite'
  | 'NegativeWhiteDelay'
  | 'PositiveBlack'
  | 'PositiveBlackDelay'
  | 'PositiveWhite'
  | 'PositiveWhiteDelay'
  | 'KonnectSymbol';
